<template>
<div>
      <div class="case-top-line">
      <div class="case-top-line-left">
        <div :class="['case-top-dot', 'indikator', !project_info.is_archived ? 'i-g' : project_info.is_archived && !project_info.is_destroyed ? 'i-g-archived': 'i-g-destroyed' ]"></div>
        <div class="case-name">{{ project_info.name }}</div>
        <div
          @click="changeView('edit')"
          v-if="is_permission_inside('project.edit')"
          class="edit-case-name add-button add-pen"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            viewBox="0 0 13 13"
          >
            <g>
              <g>
                <path
                  fill="#7b7b8a"
                  d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                />
              </g>
            </g>
          </svg>
        </div>
      </div>
      <div class="case-top-line-right">
        <div class="case-actions-date">
          <div class="case-kreiran">
            Kreiran: <b>{{ project_info.datum_pocetka != undefined ? showDate(project_info.datum_pocetka) :'' }}</b>
          </div>
          <div v-if="project_info.is_archived" class="case-kreiran">
            Završen: <b>{{ project_info.datum_arhiviranja ? showDate(project_info.datum_arhiviranja) : 'Nepoznato' }}</b>
          </div>
          <!-- <div v-if="project_info.is_destroyed" class="case-kreiran">
            Uništen: <b>{{ project_info.datum_unistenja ? showDate(project_info.datum_unistenja) : 'Nepoznato' }}</b>
          </div> -->
        </div>
      </div>
    </div>
  <div class="case-tabs">
    <div
      v-if="is_permission_inside('project.task.read')"
      :class="[
        'case-tab',
        'case-tab-predmet',
        'case-tab-mobile',
        current_tab == 'Planer' ? 'active' : '',
      ]"
      @click="changeView('')"
    >
      Planer
    </div>
    <div
    v-if="is_permission_inside('project.calendar.read')"
      :class="['case-tab', 'case-tab-spisi', 'case-tab-mobile', current_tab == 'Kalendar' ? 'active' : '',]"
      @click="changeView('kalendar')"
    >
      Kalendar
    </div>
    <div class="case-tab-wrapper-subtabs" id="kalendar-maintab">
      <div
        v-if="is_permission_inside('project.task.read')"
        :class="[
          'case-tab',
          'case-tab-subtabs',
          'case-tab-predmet',
          current_tab == 'Planer' || current_tab == 'Kalendar' ? 'active' : '',
        ]"
        @click="changeView('')"
      >
        <span>Aktivnosti</span>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M8 1.2C4.2504 1.2 1.2 4.2504 1.2 8C1.2 11.7496 4.2504 14.8 8 14.8C11.7496 14.8 14.8 11.7496 14.8 8C14.8 4.2504 11.7496 1.2 8 1.2ZM8 16C3.5888 16 0 12.4112 0 8C0 3.5888 3.5888 0 8 0C12.4112 0 16 3.5888 16 8C16 12.4112 12.4112 16 8 16Z" fill="#65656D"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99965 10.235C7.84045 10.235 7.68685 10.1718 7.57485 10.0582L4.79805 7.26941C4.56365 7.03421 4.56525 6.65421 4.79965 6.42061C5.03485 6.18701 5.41485 6.18701 5.64845 6.42221L7.99965 8.78541L10.3516 6.42221C10.5852 6.18701 10.9652 6.18701 11.2004 6.42061C11.4348 6.65421 11.4356 7.03421 11.202 7.26941L8.42445 10.0582C8.31245 10.1718 8.15885 10.235 7.99965 10.235Z" fill="#65656D"/>
        </svg>
      </div>
      <div class="subtabs" id="subtabs-kalendar">
        <div
        v-if="is_permission_inside('project.calendar.read')"
          :class="['sub-tab', 'case-tab-spisi', current_tab == 'Kalendar' ? 'active' : '',]"
          @click="changeView('kalendar')"
        >
          Kalendar
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
          <path d="M1.06055 5.8539H12.7452" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.81234 8.4142H9.81841" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.90316 8.4142H6.90923" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.98812 8.4142H3.99419" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.81234 10.9618H9.81841" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M6.90316 10.9618H6.90923" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M3.98812 10.9618H3.99419" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.55073 1V3.1573" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.25483 1V3.1573" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.67845 2.03516H4.12764C2.20247 2.03516 1 3.10761 1 5.07893V11.0115C1 13.0138 2.20247 14.1111 4.12764 14.1111H9.67238C11.6036 14.1111 12.8 13.0324 12.8 11.0611V5.07893C12.8061 3.10761 11.6097 2.03516 9.67845 2.03516Z" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div
          v-if="is_permission_inside('project.task.read')"
          :class="[
            'sub-tab',
            'case-tab-predmet',
            current_tab == 'Planer' ? 'active' : '',
          ]"
          @click="changeView('')"
        >
          Planer
          <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
          <path fill-rule="evenodd" clip-rule="evenodd" d="M9.07697 1.5H3.92243C2.12616 1.5 1 2.77184 1 4.57168V9.42832C1 11.2282 2.12081 12.5 3.92243 12.5H9.07638C10.8786 12.5 12 11.2282 12 9.42832V4.57168C12 2.77184 10.8786 1.5 9.07697 1.5Z" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M4.38281 7.00008L5.79438 8.41106L8.61633 5.58911" stroke="#606076" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>

    </div>
    <div
      :class="[
        'case-tab',
        'case-tab-sudionici',
        current_tab == 'Sudionici' ? 'active' : '',
      ]"
      @click="changeView('participants')"
    >
      Sudionici
    </div>
    <div
      v-if="is_permission_inside('project.radni.read')"
      :class="['case-tab', 'case-tab-spisi', current_tab == 'Dokumenti' ? 'active' : '',]"
      @click="changeView('radni')"
    >
      Dokumenti
    </div>
    <div
    v-if="is_permission_inside('project.comunication.read')"
      :class="['case-tab', 'case-tab-spisi', current_tab == 'Komunikacija' ? 'active' : '',]"
      @click="changeView('komunikacija')"
    >
      Komunikacija
    </div>
    <div
      :class="['case-tab', 'case-tab-spisi', current_tab == 'Messenger' ? 'active' : '',]"
      @click="changeView('messenger')"
    >
      Messenger
    </div>
     
    <!-- <div
      :class="['case-tab', 'case-tab-pošta', current_tab == 'Komunikacija'?'active':'']"
      @click="changeView('mail')"
    >
      Komunikacija
    </div> -->
    
  </div>
</div>

</template>

<script>
import moment from "moment";
import permissioner from "@/services/permissioner.js";
import gsap from 'gsap';
import $ from 'jquery';

export default {
    props:['current_tab', "project_info", "permission"],
  methods: {
    is_permission_inside(wanted_permission) {
     return permissioner.check_project_permission(wanted_permission)
    },
    changeView(nastavak) {
      if (this.$route.path.includes('finished-projects')) {
        this.$router.push("/finished-projects/" + this.$route.params.uid + "/"+nastavak);
      } else {
        this.$router.push("/projects/" + this.$route.params.uid + "/"+nastavak);
      }
    },
    showDate(date) {
      return moment(date.toString()).format("l");
    },
  },
  mounted() {
    setTimeout(() => {
      this.$store.state.paginacija.title = "Projekti";
      this.$store.state.paginacija.subpages = [this.project_info.broj_projekta];
      this.$store.state.paginacija.back_link = '/projects'
      console.log(this.current_tab);
    }, 500);
    const sub = document.getElementById("subtabs-kalendar");
    $('#kalendar-maintab').off().hover(
      function(){
        gsap.fromTo(sub,0.3, {display:'none'},{display:'block'})
        gsap.fromTo(sub, 0.3, { opacity: 0}, { opacity: 1 });
      },
      function(){
        gsap.fromTo(sub, 0.3, {display:'block'},{display:'none'})
        gsap.fromTo(sub, 0.3, { opacity: 1}, { opacity: 0 });
      }
    );
  },
  destroyed(){
    $("#kalendar-maintab").off();
  }
};
</script>